// Keep in sync with devmain\translator\client\public\Translation.h
export const TranslationContentType = {
    Undefined: 0,
    Html: 1,
    TextSelection: 2,
    PlainText: 3,
    RTF: 4,
    Unsupported: 5,
};
